import { useState } from "react";
import { Loader2, Sparkles } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Panel } from "@/components/PageHeader";
import { Markdown } from "@/components/Markdown";
import { METRICS } from "@/components/flyers/StoreTable";
import { api, errMsg, fdatetime } from "@/lib/api";
import { useFeature } from "@/context/AuthContext";

export const FlyerAiComment = ({ flyer, params, canWrite }) => {
  const aiOn = useFeature("ai");
  const [doc, setDoc] = useState(flyer.ai_comment || null);
  const [busy, setBusy] = useState(false);
  const gen = async () => {
    setBusy(true);
    try { setDoc((await api.post(`/flyers/${flyer.id}/ai-comment`, params, { timeout: 90000 })).data); toast.success("Commento IA generato"); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  if (!aiOn) return null;
  return (
    <Panel testId="flyer-ai-panel" title={<span className="flex items-center gap-2"><Sparkles className="h-4 w-4 text-blue-600" />Commento IA</span>}
      action={canWrite && <Button size="sm" data-testid="flyer-ai-generate" disabled={busy} className="bg-blue-600 hover:bg-blue-700" onClick={gen}>
        {busy ? <><Loader2 className="mr-1 h-4 w-4 animate-spin" />Analisi in corso...</> : doc ? "Rigenera commento" : "Genera commento IA"}</Button>}>
      <div className="p-5">
        {!doc && !busy && <p className="text-sm text-slate-400" data-testid="flyer-ai-empty">Nessun commento ancora. L'IA spiegherà i risultati e suggerirà azioni per le sedi sotto media, usando il confronto, la misura e la soglia scelti sopra.</p>}
        {busy && !doc && <p className="text-sm text-slate-400">L'IA sta leggendo i dati del volantino (può richiedere fino a un minuto)...</p>}
        {doc && <>
          <div className="text-sm" data-testid="flyer-ai-text"><Markdown text={doc.text} /></div>
          <p className="mt-4 border-t border-slate-100 pt-3 text-[11px] text-slate-400" data-testid="flyer-ai-meta">
            Generato il {fdatetime(doc.created_at)} da {doc.by} · confronto {doc.compare === "yoy" ? "anno prima" : "periodo precedente"} · {METRICS[doc.metric]?.[0]} · soglia {doc.threshold}%{doc.stores_filtered ? " · sedi filtrate" : ""}</p>
        </>}
      </div>
    </Panel>
  );
};
